// Message.js
import React, { useState } from 'react';
import './Message.css';

const Message = () => {
  // Tableau d'exemple de notifications
  const [notifications, setNotifications] = useState([
    { id: 1, message: "Nouvelle mise à jour disponible ! Il y a beaucoup de nouvelles fonctionnalités à découvrir.", timestamp: new Date(), read: false },
    { id: 2, message: "Vous avez un message privé. Cela pourrait être important, veuillez vérifier.", timestamp: new Date(), read: false },
    { id: 3, message: "Rappel de réunion à 14h. Assurez-vous d'être prêt avec les documents nécessaires pour la présentation.", timestamp: new Date(), read: false },
    { id: 4, message: "Nouveau message de votre collègue. Il semble que vous ayez un fichier à examiner.", timestamp: new Date(), read: false },
    { id: 5, message: "Alerte de sécurité : votre mot de passe doit être changé dans les 48 heures.", timestamp: new Date(), read: false },
    { id: 6, message: "Demande de rendez-vous pour la réunion de demain. Veuillez confirmer votre présence.", timestamp: new Date(), read: false },
    { id: 7, message: "Le système a détecté une nouvelle mise à jour importante. Assurez-vous de redémarrer votre appareil.", timestamp: new Date(), read: false },
    { id: 8, message: "Notification de maintenance prévue pour ce soir. Il est recommandé de sauvegarder votre travail.", timestamp: new Date(), read: false }
  ]);

  // État pour gérer la notification active
  const [activeNotification, setActiveNotification] = useState(null);

  // Fonction pour activer une notification et afficher son contenu complet
  const handleNotificationClick = (id) => {
    setActiveNotification(id);
  };

  return (
    <div className="notifications-container">
      <h1 className="mainhead1">Notifications</h1>
      <div className="notification-list">
        {notifications.map((notification) => (
          <div
            key={notification.id}
            className={`notification ${notification.id === activeNotification ? 'active' : ''}`}
            onClick={() => handleNotificationClick(notification.id)}
          >
            <div className="notification-icon">
              {/* Icône de notification */}
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 22c1.104 0 2-.896 2-2H10c0 1.104.896 2 2 2zM18 16V10c0-3.866-3.134-7-7-7S4 6.134 4 10v6l-2 2v1h16v-1l-2-2z" />
              </svg>
            </div>
            <div className="notification-details">
              {/* Affichage du message tronqué ou complet */}
              <p className="notification-text">
                {notification.id === activeNotification
                  ? notification.message
                  : `${notification.message.slice(0, 40)}...`}
              </p>
              <p className="notification-time">{notification.timestamp.toLocaleString()}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Message;
